import { MapPin, Truck } from '@phosphor-icons/react';
import { useState } from 'react';
import RequestLoadModal from '../modals/RequestLoadModal';
import HomeActionCard from './HomeActionCard';

// Load Board V1 — Web (THT-695). "Find Me Freight" entry point on CustomerHome,
// ported from the mobile RequestLoadCard: a card with a "NEW" badge, an icon +
// title + subtitle and an orange CTA that opens the request modal. It shares
// its row with RequestRentalEntry, half the width each (see HomeActionCard for
// the layout). Encapsulates its own modal
// open-state and the pre-active gate so CustomerHome drops one element into each
// of its three screen-size branches. Hidden for pre-active/demo accounts so they
// can never email the real dispatcher.

interface RequestLoadEntryProps {
  isPreActive: boolean;
}

const RequestLoadEntry = ({ isPreActive }: RequestLoadEntryProps) => {
  const [isOpen, setIsOpen] = useState(false);

  if (isPreActive) return null;

  return (
    <>
      <HomeActionCard
        testIdPrefix="requestLoad"
        icon={<Truck size={18} className="text-primary" />}
        title="Find Me Freight"
        subtitle="We'll find and book loads for you."
        ctaIcon={<MapPin size={16} weight="fill" />}
        ctaLabel="Find Me Freight"
        onClick={() => setIsOpen(true)}
        isNew
      />

      {/* Mounted only while open. The modal starts async work the user can
          walk away from (a 30s geolocation fix, the submit POST), and keeping
          the instance alive across closes meant a late resolve could write
          into the NEXT open — a stale error banner, a re-filled pickup, or the
          "Request sent" success view on a blank form. Unmounting makes each
          open a genuinely fresh form; the modal also guards its own awaits. */}
      {isOpen && (
        <RequestLoadModal isOpen={isOpen} onClose={() => setIsOpen(false)} />
      )}
    </>
  );
};

export default RequestLoadEntry;
